<script>
  import { onMount } from "svelte";
  import { Loading } from "carbon-components-svelte";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import PotentialScoutSurvey from "./Survey.svelte";
  import TaskFeedbackSurvey from "./TaskFeedbackSurvey.svelte";

  let loading = true;
  let taskFeedback = false;

  onMount(async () => {
    const surveyUser = new URLSearchParams(window.location.search).get("survey_user");
    if (surveyUser) {
      try {
        const response = await fetchWithSession(`/api/knextractor/task-feedback-surveys/by-user/${surveyUser}`);
        taskFeedback = response.ok;
      } catch (_) {
        taskFeedback = false;
      }
    }
    loading = false;
  });
</script>

{#if loading}
  <div class="survey_router_loading"><Loading withOverlay={false} /></div>
{:else if taskFeedback}
  <TaskFeedbackSurvey />
{:else}
  <PotentialScoutSurvey />
{/if}

<style>
  .survey_router_loading { min-height: 100vh; display: grid; place-items: center; }
</style>
